var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 34,
    width: 34,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillOpacity: 0.1,
    height: 34,
    rx: 17,
    width: 34
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 33,
    rx: 16.5,
    stroke: "#fff",
    strokeOpacity: 0.2,
    width: 33,
    x: 0.5,
    y: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.368 14.263A2.375 2.375 0 0 0 8 16.632 2.375 2.375 0 0 0 10.368 19a2.375 2.375 0 0 0 2.369-2.368 2.375 2.375 0 0 0-2.369-2.369zM23.632 14.263a2.375 2.375 0 0 0-2.368 2.369A2.375 2.375 0 0 0 23.632 19a2.375 2.375 0 0 0 2.369-2.368 2.375 2.375 0 0 0-2.369-2.369zM17 14.263a2.375 2.375 0 0 0-2.368 2.369A2.375 2.375 0 0 0 17 19a2.375 2.375 0 0 0 2.369-2.368A2.375 2.375 0 0 0 17 14.263z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.31969fade44a0721aa8f68a1503211df.svg";
export { ForwardRef as ReactComponent };